import { render, staticRenderFns } from "./v-nav-button.vue?vue&type=template&id=6bf67928&scoped=true&"
import script from "./v-nav-button.vue?vue&type=script&lang=ts&"
export * from "./v-nav-button.vue?vue&type=script&lang=ts&"
import style0 from "./v-nav-button.vue?vue&type=style&index=0&id=6bf67928&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf67928",
  null
  
)

export default component.exports